import React, { useState, useEffect } from "react";

function CookieDisclosure() {
  const [hasCookie, setHasCookie] = useState(false);

  useEffect(() => {
    // Check if a value exists in local storage
    const value = localStorage.getItem("shopCookiePermission");
    if (value !== null) {
      setHasCookie(true);
    }
  }, []);

  return (
    <div>
      {!hasCookie && (
        <div className='cookie-disclosure-container'>
          <div className='cookie-content'>
            <div>
              This website uses cookies to improve your experience. By using this website you agree to our{" "}
              <strong>
                <a href='https://www.comporium.com/privacy-policy/' target='_blank' rel='noopener noreferrer'>
                  Privacy Policy
                </a>
              </strong>
              .
            </div>
            <p>
              <strong>
                <a href='https://www.comporium.com/privacy-policy/' target='_blank' rel='noopener noreferrer'>
                  Read More
                </a>
              </strong>
            </p>
            <button
              className='btn btn-primary'
              data-testid='cookie-accept'
              onClick={() => {
                localStorage.setItem("shopCookiePermission", "true");
                setHasCookie(true);
              }}>
              <strong>ACCEPT ALL</strong>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CookieDisclosure;
